export default __webpack_public_path__ + "static/media/social_play_logo_horizontal.153f4f7a.png";